import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./BigMenu_6_square.css";

export default class BigMenu_6_square extends Component {
  constructor(props) {
    super(props);
    let data = { boxes: [] , ...props.data };
    this.state = {
      data: {
        ...data,
        boxes:this.props.data.boxes.length === 5 ? this.props.data.boxes.concat({no_link:'true',url:''}) : this.props.data.boxes
      },
      config: { config: [], ...props.config },
      length:
        data.boxes.length +
        data.boxes
          .filter(item => item.hasOwnProperty("sub_menu"))
          .reduce((a, b) => a + b.sub_menu.length, 0),
      width: 0,
      height: 0,

    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMountt() {
	  var pathArray = window.globalUrl.split('/');
	  var zeroPart = pathArray[1];
	  var firstPart = pathArray[1];
	  var secondPart = pathArray[2];
	  var thirdPart = pathArray[3];
	  var fourthPart = pathArray[4];
	  // console.log("https:/" + firstPart + "/" + secondPart + "/" + thirdPart + "/" + fourthPart + "/web_config");
	  window.apiLink = "https:/" + firstPart + "/" + secondPart + "/" + thirdPart + "/" + fourthPart + "/web_config"

	  alert("placki123 "+  window.apiLink);
  }



  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    // console.log("mucha1", this.data);
	var pathArray = window.globalUrl.split('/');
	var zeroPart = pathArray[1];
	var firstPart = pathArray[1];
	var secondPart = pathArray[2];
	var thirdPart = pathArray[3];
	var fourthPart = pathArray[4];


    if (this.state.width > 600) {
      return (
        <div className="BigMenu BigMenu--6 col-xs-12 col-ms-12 col-lg-12">
          <div className="row">
            <div className="gb-parentpanel-hoder gb-parentpanel-hoder--6">
              <div className="concurs-panels-holder panels-holder-desctopset menupanel-container">
                <div
                  className="festivalpg-panelholder-mask"
                  style={{ backgroundColor: "#" + `#${this.state.config.gbcolor}` }}
                />

                {this.state.data.boxes.map((object, i) => {
                  // console.log(object,'dlugosc');




				  let columnSizeSwitch = '';
				  if(this.state.data && this.state.data.boxes.length == '6') {
					  // console.log(secondPart);
					  columnSizeSwitch = "sixbox"
				  }
				  else {
					  columnSizeSwitch = ""
				  }






                  if (
                    typeof object.sub_menu !== "undefined" &&
                    object.sub_menu.constructor === Array
                  ) {
                    if (object.url && !object.no_link) {
                      // link box 6 suare start
                      return (
                        //
                        <div
                          className={`festivalpg-panelholder festivalpg-panelholder--6 ${columnSizeSwitch}`}
                          key={object.id}
                          style={{
                            borderColor: `#${this.state.config.gbcolor}`,
							backgroundImage: `url(${object.background_image})`
                          }}
                        >
                          {object.sub_menu ? (
                            <div className="festivalpg-panelbox">
                              <span className="festival-hover-mask" />
                              <div className="fest-hover-desc">
                                <p className="festivalpg-paneltitle font-fix-title"
                                   onClick={(e) =>{window.location.href = `${object.url}`}}
                                   style={{cursor:'pointer'}}
                                   dangerouslySetInnerHTML={{__html: object.name}}
                                />
                                <div className="festivalpg-paneldescriptoin">
                                  <ul className="panel-menu-list font-fix">
                                    {object.sub_menu && object.submenu
                                      ? object.sub_menu.map((
                                          object1,
                                          a
                                        ) => {
                                          if (
                                            object1.url.indexOf("http") > -1
                                          ) {
                                            return (
                                              <li key={a}>
                                                <a
                                                  target="_blank"
                                                  href={object1.url}
                                                >
                                                  {object1.name}
                                                </a>
                                              </li>
                                            );
                                          } else {
                                            return (
                                              <li key={a}>
                                                <Link to={object1.url}>
                                                  {object1.name}
                                                </Link>
                                              </li>
                                            );
                                          }
                                        })
                                      : ""}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <Link to={object.url}>
                              <div className="festivalpg-panelbox">
                                <span className="festival-hover-mask" />
                                <div className="fest-hover-desc">
                                  <p className="festivalpg-paneltitle">
                                    {object.name}
                                  </p>
                                  <div className="festivalpg-paneldescriptoin">
                                    <ul className="panel-menu-list">
                                      {object.sub_menu
                                        ? object.sub_menu.map(function(
                                            object1,
                                            a
                                          ) {
                                            if (
                                              object1.url.indexOf("http") > -1
                                            ) {
                                              return (
                                                <li key={a}>
                                                  <a
                                                    target="_blank"
                                                    href={object1.url}
                                                  >
                                                    {object1.name}
                                                  </a>
                                                </li>
                                              );
                                            } else {
                                              return (
                                                <li key={a}>
                                                  <Link to={"/"+object1.url}>
                                                    {object1.name}
                                                  </Link>
                                                </li>
                                              );
                                            }
                                          })
                                        : ""}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </Link>
                          )}
                        </div>
                        //
                      );
                      //
                    }
                    return (
                      //
                      <div
                        className={`festivalpg-panelholder festivalpg-panelholder--6 ${columnSizeSwitch}`}
                        key={object.id}
                        style={{
							borderColor: `#${this.state.config.gbcolor}`,
								backgroundImage: `url(${object.background_image})`

					}}
                      >
                        {object.sub_menu ? (
                          <div className="festivalpg-panelbox">
                            <span className="festival-hover-mask" />
                            <div className="fest-hover-desc">
                              <p className="festivalpg-paneltitle font-fix-title" dangerouslySetInnerHTML={{__html: object.name}}/>
                              <div className="festivalpg-paneldescriptoin">
                                <ul className="panel-menu-list font-fix">
                                  {object.sub_menu && object.submenu
                                    ? object.sub_menu.map((object1, a) => {
                                        if (object1.url.indexOf("http") > -1) {
                                          return (
                                            <li key={a}>
                                              <a
                                                target="_blank"
                                                href={object1.url}
                                              >
                                                {object1.name}
                                              </a>
                                            </li>
                                          );
                                        } else {
                                          return (
                                            <li key={a}>
                                              <Link to={"/"+object1.url}>
                                                {object1.name}
                                              </Link>
                                            </li>
                                          );
                                        }
                                      })
                                    : ""}
                                </ul>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <Link to={object.url}>
                            <div className="festivalpg-panelbox ">
                              <span className="festival-hover-mask" />
                              <div className="fest-hover-desc">
                                <p className="festivalpg-paneltitle">
                                  {object.name}
                                </p>
                                <div className="festivalpg-paneldescriptoin">
                                  <ul className="panel-menu-list">
                                    {object.sub_menu
                                      ? object.sub_menu.map((
                                          object1,
                                          a
                                        ) => {
                                          if (
                                            object1.url.indexOf("http") > -1
                                          ) {
                                            return (
                                              <li key={a}>
                                                <a
                                                  target="_blank"
                                                  href={object1.url}
                                                >
                                                  {object1.name}
                                                </a>
                                              </li>
                                            );
                                          } else {
                                            return (
                                              <li key={a}>
                                                <Link to={"/"+object1.url}>
                                                  {object1.name}
                                                </Link>
                                              </li>
                                            );
                                          }
                                        })
                                      : ""}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </Link>
                        )}
                      </div>
                      //
                    );
                  } else {
                    return (

                      <div
                        id={this.state.config.gbcolor}
                        className={`festivalpg-panelholder festivalpg-panelholder--6 ${columnSizeSwitch}`}
                        key={object.id}
                        style={{
							borderColor: `#${this.state.config.gbcolor}`,
						 	backgroundImage: `url(${object.background_image})`}}
                      >
                        {object.sub_menu ? (
                          <div className="festivalpg-panelbox ">
                            <span className="festival-hover-mask" />
                            <div className="fest-hover-desc">
                              <p className="festivalpg-paneltitle">
                                {object.name}
                              </p>
                              <div className="festivalpg-paneldescriptoin">
                                <ul className="panel-menu-list">
                                  {object.sub_menu
                                    ? object.sub_menu.map(function(object1, a) {
                                        if (object1.url.indexOf("http") > -1) {
                                          return (
                                            <li key={a}>
                                              <a
                                                target="_blank"
                                                href={object1.url}
                                              >
                                                {object1.name}
                                              </a>
                                            </li>
                                          );
                                        } else {
                                          return (
                                            <li key={a}>
                                              <Link to={"/"+object1.url}>
                                                {object1.name}
                                              </Link>
                                            </li>
                                          );
                                        }
                                      })
                                    : ""}
                                </ul>
                              </div>
                            </div>
                          </div>
                        ) : (
													<div>
														{object.no_link?
															<div>
																<div className="festivalpg-panelbox ">
																	<span className="festival-hover-mask" />
																	<div className="fest-hover-desc">
																		<p className="festivalpg-paneltitle font-fix-title" dangerouslySetInnerHTML={{__html: object.name}}/>
																		<div className="festivalpg-paneldescriptoin">
																			<ul className="panel-menu-list font-fix">
																				{object.sub_menu
																					? object.sub_menu.map(function(
																							object1,
																							a
																						) {
																							if (
																								object1.url.indexOf("http") > -1
																							) {
																								return (
																									<li key={a}>
																										<a
																											target="_blank"
																											href={object1.url}
																										>
																											{object1.name}
																										</a>
																									</li>
																								);
																							} else {
																								return (
																									<li key={a}>
																										<Link to={object1.url}>
																											{"/"+object1.url}
																										</Link>
																									</li>
																								);
																							}
																						})
																					: ""}
																			</ul>
																		</div>
																	</div>
																</div>
															</div>:
															<a href={object.url}>
																<div className="festivalpg-panelbox test123">
																	<span className="festival-hover-mask" />
																	<div className="fest-hover-desc">
																		<p className="festivalpg-paneltitle font-fix-title" dangerouslySetInnerHTML={{__html: object.name}}/>
																		<div className="festivalpg-paneldescriptoin">
																			<ul className="panel-menu-list font-fix">
																				{object.sub_menu
																					? object.sub_menu.map(function(
																							object1,
																							a
																						) {
																							if (
																								object1.url.indexOf("http") > 0
																							) {
																								return (
																									<li key={a}>
																										<a
																											target="_blank"
																											href={object1.url}
																										>
																											{object1.name}
																										</a>
																									</li>
																								);
																							} else {
																								return (
																									<li key={a}>
																										<Link to={"/"+object1.url}>
																											{object1.name}
																										</Link>
																									</li>
																								);
																							}
																						})
																					: ""}
																			</ul>
																		</div>
																	</div>
																</div>
															</a>

														}
													</div>
                        )}
                      </div>
                    );
                  }
                })}
                {/* end of mapping */}
              </div>
            </div>
          </div>
        </div>
      );
    }
    // Small menu - mobile
    else {
      return (
        <div className="BigMenu col-xs-12 col-ms-12 col-lg-12">
          <div className="row">
            <div
              className="gb-parentpanel-hoder"
              style={{ height: this.state.length * 35 + 35 }}
            >
              <div className="concurs-panels-holder panels-holder-desctopset">
                <div
                  className="festivalpg-panelholder-mask"
                  style={{ backgroundColor: "#" + this.state.config.gbcolor }}
                />

                {this.state.data.boxes.map((object, i) => {
                  if (
                    typeof object.sub_menu !== "undefined" &&
                    object.sub_menu.constructor === Array
                  ) {
                    return (
                      <div
                        className="festivalpg-panelholder "
                        key={object.id}
                        style={{
                          borderColor: `#${this.state.config.gbcolor}`,
                          height: object.sub_menu.length * 35 + 35
                        }}
                      >
                        {object.sub_menu ? (
                          <div className="festivalpg-panelbox">
                            <span className="festival-hover-mask" />
                            <div className="fest-hover-desc">
                              <p className="festivalpg-paneltitle font-fix-title" dangerouslySetInnerHTML={{__html: object.name}}/>
                              <div className="festivalpg-paneldescriptoin">
                                <ul className="panel-menu-list font-fix">
                                  {object.sub_menu
                                    ? object.sub_menu.map(function(object1, a) {
                                        if (object1.url.indexOf("http") > -1) {
                                          return (
                                            <li key={a}>
                                              <a
                                                target="_blank"
                                                href={object1.url}
                                              >
                                                {object1.name}
                                              </a>
                                            </li>
                                          );
                                        } else {
                                          return (
                                            <li key={a}>
                                              <Link to={object1.url}>
                                                {object1.name}
                                              </Link>
                                            </li>
                                          );
                                        }
                                      })
                                    : ""}
                                </ul>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <Link to={object.url}>
                            <div className="festivalpg-panelbox">
                              <span className="festival-hover-mask" />
                              <div className="fest-hover-desc">
                                <p className="festivalpg-paneltitle ">
                                  {object.name}
                                </p>
                                <div className="festivalpg-paneldescriptoin">
                                  <ul className="panel-menu-list">
                                    {object.sub_menu
                                      ? object.sub_menu.map((
                                          object1,
                                          a
                                        ) => {
                                          if (
                                            object1.url.indexOf("http") > -1
                                          ) {
                                            return (
                                              <li key={a}>
                                                <a
                                                  target="_blank"
                                                  href={object1.url}
                                                >
                                                  {object1.name}
                                                </a>
                                              </li>
                                            );
                                          } else {
                                            return (
                                              <li key={a}>
                                                <Link to={object1.url}>
                                                  {object1.name}
                                                </Link>
                                              </li>
                                            );
                                          }
                                        })
                                      : ""}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </Link>
                        )}
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className="festivalpg-panelholder"
                        key={object.id}
                        style={{ borderColor: `#${this.state.config.gbcolor}` }}
                      >
                        {object.sub_menu && object.submenu ? (
                          <div className="festivalpg-panelbox">
                            <span className="festival-hover-mask" />
                            <div className="fest-hover-desc">
                              <p className="festivalpg-paneltitle ">
                                {object.name}
                              </p>
                              <div className="festivalpg-paneldescriptoin">
                                <ul className="panel-menu-list">
                                  {object.sub_menu
                                    ? object.sub_menu.map((object1, a)=> {
                                        if (object1.url.indexOf("http") > -1) {
                                          return (
                                            <li key={a}>
                                              <a
                                                target="_blank"
                                                href={object1.url}
                                              >
                                                {object1.name}
                                              </a>
                                            </li>
                                          );
                                        } else {
                                          return (
                                            <li key={a}>
                                              <Link to={object1.url}>
                                                {object1.name}
                                              </Link>
                                            </li>
                                          );
                                        }
                                      })
                                    : ""}
                                </ul>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <Link to={object.url}>
                            <div className="festivalpg-panelbox ">
                              <span className="festival-hover-mask" />
                              <div className="fest-hover-desc">
                                <p className="festivalpg-paneltitle font-fix-title" dangerouslySetInnerHTML={{__html: object.name}}/>
                                <div className="festivalpg-paneldescriptoin">
                                  <ul className="panel-menu-list font-fix">
                                    {object.sub_menu
                                      ? object.sub_menu.map(function(
                                          object1,
                                          a
                                        ) {
                                          if (
                                            object1.url.indexOf("http") > -1
                                          ) {
                                            return (
                                              <li key={a}>
                                                <a
                                                  target="_blank"
                                                  href={object1.url}
                                                >
                                                  {object1.name}
                                                </a>
                                              </li>
                                            );
                                          } else {
                                            return (
                                              <li key={a}>
                                                <Link to={object1.url}>
                                                  {object1.name}
                                                </Link>
                                              </li>
                                            );
                                          }
                                        })
                                      : ""}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </Link>
                        )}
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/Components/Elements/BigMenu_6_square/BigMenu_6_square.js